import React from 'react';
import Modal from './Modal';

export default function RulebookModal({ onClose }) {
  return (
    <Modal title="📖 Rule Book" onClose={onClose}>
      <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>

        <div className="rulebook-section">
          <h3>🎯 Objective</h3>
          <p>
            Collect as much money as possible while keeping your Energy Points (EP) alive.
            Beat the leaderboard!
          </p>
        </div>

        <div className="rulebook-section">
          <h3>⚡ Energy Rules</h3>
          <ul>
            <li>Each move costs EP</li>
            <li>Max EP = 350 — don't overfill!</li>
            <li>Game ends if EP hits 0 OR exceeds 350</li>
            <li>As levels increase, more EP is drained per move</li>
          </ul>
        </div>

        <div className="rulebook-section">
          <h3>🍔 Items on the Grid</h3>
          <ul>
            <li>🍔 Burger = +35 EP</li>
            <li>🍎 Apple  = +20 EP</li>
            <li>💰 Money  = +50 Score Points</li>
          </ul>
        </div>

        <div className="rulebook-section">
          <h3>🕹️ Controls</h3>
          <ul>
            <li>Arrow keys or WASD (keyboard)</li>
            <li>On-screen D-Pad (touch / mobile)</li>
            <li>The grid wraps — walk off one edge, appear on the other!</li>
          </ul>
        </div>

        <div className="rulebook-section">
          <h3>📈 Levels</h3>
          <ul>
            <li>Level increases every 30 seconds</li>
            <li>Higher level = avatar moves faster</li>
            <li>Faster movement = more EP lost per move</li>
          </ul>
        </div>

        <div className="rulebook-section">
          <h3>🏆 Scoring</h3>
          <ul>
            <li>1 Money bag = 50 points</li>
            <li>Survive longer to collect more</li>
            <li>High score is saved to the leaderboard</li>
          </ul>
        </div>

      </div>
    </Modal>
  );
}